import { createContext, useContext } from "react";

import { ProductDummyRoomFormModelContext } from "../../_shared/context/context";

import type { ProductDummyRoomFormModelContextType } from "../../_shared/context/context";

export type ProductDummyExistingRoomFormModelContextType = {
	onUpdate: () => void;
} & ProductDummyRoomFormModelContextType;

export const ProductExistingDummyRoomFormModelContext =
	createContext<ProductDummyExistingRoomFormModelContextType | null>(null);

export const ProductExistingDummyRoomFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductDummyExistingRoomFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductExistingDummyRoomFormModelContext.Provider value={value}>
			<ProductDummyRoomFormModelContext.Provider value={value}>
				{children}
			</ProductDummyRoomFormModelContext.Provider>
		</ProductExistingDummyRoomFormModelContext.Provider>
	);
};

export const useProductExistingDummyRoomFormModelContext = () => {
	const context = useContext(ProductExistingDummyRoomFormModelContext);

	if (!context) {
		throw new Error(
			"useProductExistingDummyRoomFormModelContext must be used within a ProductExistingDummyRoomFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
